<template>
  <div class="body">


    <button class="button" @click="open">点击打开</button>
    <el-dialog
      width="70%"
      :visible.sync="dialogVisible"
      :show-close="false"
      :lock-scroll="false"
      :center="true"
      title=""
      top="20px"
    >
      <div slot="title" class="dialog-title">
        <img src="../assets/img/case/重点工程_详情图@2x.png">
      </div>
      <img class="dialog-close" src="../assets/img/case/icon_close@2x.png" @click="close">
      <div slot="" class="dialog-content">
        <h5>佛山市南海区全数字治安视频监控系统</h5>
        <p>般极活性济众己率况八史次等较音与县断青话号选子次成流加约元派产王日线消精军知比口门对每眼形过政保经同改金特极近那性京段元物土机亲气细调治。次设接广四物飞还心时严业整面研东量意直织省社立日号当把直传度决次取但提深非。究心意包四据张证总别斯热非习易土没业识反气没各书明是级合史着包小十重一思根响较区场员及相长处百交学太下四许。油约更道队对织般带参指情林被公则权铁今石片称素六四非快满之养原华空指然个器理干花县科共极铁走五党更放布段明大容次去了农那导问。</p>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  
  </div>
</template>

<script>
export default {
    name:'download',
    data(){
        return {
            dialogVisible: false
        }
    },
    methods:{
        open(){
            // document.body.parentNode.style.overflowY= "hidden"
            this.dialogVisible = true
        },
        close(){
            // document.body.parentNode.style.overflowY = "auto";
            this.dialogVisible = false
        }
}
};

</script>


<style scoped>
.body{
    height: 2000px;
}

.dialog-title img{
    padding: 20px 20px 0 20px;
    width: 100%;
    height: 100%;
    object-fit:cover;
}

.dialog-close{
    position: absolute;
    top: -16px;
    right: -56px;
    width: 32px;
    height: 32px;
}
.dialog-content{
    padding: 0 13px;
    font-size: 18px;
    color: rgba(29, 30, 32, 1);
    letter-spacing: 1px;
    line-height: 25px;
}
.dialog-content p {
    margin-top: 15px;
    font-size: 14px;
    color: rgba(29, 29, 29, 0.62);
    line-height: 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/download.vue